export default __webpack_public_path__ + "static/mona-3bfebc9dadbac0c134b2b6145f3f9450.png";